export default __webpack_public_path__ + "static/media/004-popsicle.69ac8a29.svg";